export const STRIPE_ACCOUNT_STATUS = {
    COMPLETE: 1,
    COMPLETE_DISABLED: 2,
    INCOMPLETE: 3,
    STANDARD_COMPLETE: 4,
    STANDARD_INCOMPLETE: 5,
    NO_ACCOUNT: 6
};
